import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.76186 7.00092L0.25653 1.4956C-0.0855103 1.15385 -0.0855103 0.599346 0.25653 0.257598C0.59857 -0.0844419 1.15249 -0.0844419 1.49453 0.257598L6.99985 5.76292L12.5055 0.257598C12.8475 -0.0844419 13.4014 -0.0844419 13.7435 0.257598C14.0855 0.599346 14.0855 1.15385 13.7435 1.4956L8.23785 7.00092L13.7435 12.5062C14.0855 12.848 14.0855 13.4025 13.7435 13.7442C13.5724 13.915 13.3483 14.0005 13.1245 14.0005C12.9006 14.0005 12.6765 13.915 12.5055 13.744L6.99985 8.23863L1.49453 13.744C1.32351 13.915 1.09937 14.0005 0.875528 14.0005C0.651685 14.0005 0.42755 13.915 0.25653 13.744C-0.0855103 13.4022 -0.0855103 12.8477 0.25653 12.506L5.76186 7.00092Z",
		fill: "currentColor"
	})
});
export default SvgCloseIcon;
